import { render, staticRenderFns } from "./ecommerce.vue?vue&type=template&id=f09489c2&scoped=true"
import script from "./ecommerce.vue?vue&type=script&lang=js"
export * from "./ecommerce.vue?vue&type=script&lang=js"
import style0 from "./ecommerce.vue?vue&type=style&index=0&id=f09489c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f09489c2",
  null
  
)

export default component.exports